<div class="cointainer-fluid">
  <div class="row">
    <div class="col">
      <h2 i18n="@@DialogSent">
        La certificazione è stata inviata all'indirizzo specificato
      </h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div style="text-align: center">
        <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose" color="primary">Chiudi</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/request-sent-dialog/request-sent-dialog.html